import { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { WarningCircle, CheckCircle, Package, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

const META = {
  delay_detected: { icon: WarningCircle, color: "text-red-600 bg-red-50", label: "Delay" },
  delivery_confirmed: { icon: CheckCircle, color: "text-green-600 bg-green-50", label: "Delivered" },
  low_inventory: { icon: Package, color: "text-yellow-600 bg-yellow-50", label: "Inventory" },
};

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const load = () => api.get("/alerts").then((r) => setAlerts(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/alerts/${id}/read`); load(); };
  const markAll = async () => { await api.post("/alerts/read-all"); toast.success("All alerts marked read"); load(); };

  const unread = alerts.filter((a) => !a.read).length;

  return (
    <Layout title="Alerts" subtitle="In-app notifications — delays, deliveries, inventory"
      actions={unread > 0 && <Button variant="outline" data-testid="mark-all-read" onClick={markAll}><Check size={16} className="mr-1.5" />Mark all read ({unread})</Button>}>
      <div className="bg-white border border-slate-200 rounded-md divide-y divide-slate-100 max-w-3xl">
        {alerts.length === 0 && <div className="p-10 text-center text-slate-400">No alerts.</div>}
        {alerts.map((a) => {
          const m = META[a.type] || META.low_inventory;
          return (
            <div key={a.id} data-testid={`alert-${a.id}`} className={`px-5 py-4 flex items-start gap-4 ${a.read ? "opacity-60" : ""}`}>
              <div className={`h-9 w-9 rounded-md flex items-center justify-center shrink-0 ${m.color}`}><m.icon size={18} weight="duotone" /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[11px] uppercase tracking-wider font-bold text-slate-400">{m.label}</span>
                  {!a.read && <span className="h-1.5 w-1.5 rounded-full bg-blue-600" />}
                </div>
                <div className="text-sm text-slate-800 mt-0.5">{a.message}</div>
                <div className="text-xs text-slate-400 mt-1">{new Date(a.created_at).toLocaleString()}</div>
              </div>
              {!a.read && <Button size="sm" variant="ghost" data-testid={`read-${a.id}`} onClick={() => markRead(a.id)} className="text-slate-500">Mark read</Button>}
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
